import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';
import WizardSpeechPlayback from '../WizardSpeechPlayback';
import {
    pickRandomWizardIllustration,
    USE_FLAT_WIZARD_DESIGN,
    wizardIllustrationStyle,
    wizardIllustrations,
} from '../../utils/wizardIllustrations';
import './WizardStepShell.scss';

const WizardStepShell = ({
    speechText = '',
    speechAnimationKey = '',
    illustrationSrc,
    imageAltKey = 'wizard.intro_image_alt',
    children,
}) => {
    const { t } = useTranslation();
    const [fallbackIllustration, setFallbackIllustration] = useState(wizardIllustrations[0]);

    useEffect(() => {
        if (illustrationSrc) {
            return;
        }
        setFallbackIllustration(pickRandomWizardIllustration());
    }, [illustrationSrc]);

    const illustration = illustrationSrc || fallbackIllustration;
    const imageAlt = t(imageAltKey);

    if (USE_FLAT_WIZARD_DESIGN) {
        return (
            <div className="wizard-step-shell wizard-step-shell--flat wizard-flat-layout">
                <aside className="wizard-flat-art wizard-flat-art--step" aria-hidden="true">
                    <img
                        className="wizard-flat-art__img"
                        src={illustration}
                        alt=""
                    />
                </aside>
                <div className="wizard-step-shell--flat__content wizard-flat-layout__content">
                    <WizardSpeechPlayback
                        text={speechText}
                        animationKey={speechAnimationKey}
                    />
                    {children}
                </div>
            </div>
        );
    }

    return (
        <Row>
            <Col sm={3} className="text-center mb-4 mb-sm-0">
                <img
                    src={illustration}
                    alt={imageAlt}
                    style={wizardIllustrationStyle}
                />
            </Col>
            <Col sm={9}>
                <WizardSpeechPlayback
                    text={speechText}
                    animationKey={speechAnimationKey}
                />
                {children}
            </Col>
        </Row>
    );
};

export default WizardStepShell;
